// Pinned to the web-vitals 3.5 that App Bridge bundles, so these values match
// what Shopify scores. App Bridge's onReport only passes the numbers back; the
// attribution build adds which element moved / painted.
import { onCLS, onLCP } from "web-vitals/attribution"

const rect = (r) => r && [r.x, r.y, r.width, r.height].map(Math.round).join(",")

const vitals = (window.__invoiceFalconVitals = {})

onCLS(({ value, attribution: a }) => {
  vitals.cls = {
    cls_observed: value,
    cls_target: a.largestShiftTarget,
    cls_largest_shift_value: a.largestShiftValue,
    cls_largest_shift_time: a.largestShiftTime,
    cls_load_state: a.loadState,
    cls_shift_from: rect(a.largestShiftSource?.previousRect),
    cls_shift_to: rect(a.largestShiftSource?.currentRect),
  }
}, { reportAllChanges: true })

onLCP(({ value, attribution: a }) => {
  vitals.lcp = {
    lcp_observed: value,
    lcp_element: a.element,
    lcp_url: a.url,
  }
}, { reportAllChanges: true })
